import { render, staticRenderFns } from "./period-store-info.vue?vue&type=template&id=63fa7d6c&scoped=true"
import script from "./period-store-info.vue?vue&type=script&lang=js"
export * from "./period-store-info.vue?vue&type=script&lang=js"
import style0 from "./period-store-info.vue?vue&type=style&index=0&id=63fa7d6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fa7d6c",
  null
  
)

export default component.exports